<script setup lang="ts">
import { getBatteryConfig } from '@/lib/product'

defineProps<{
    status: string | undefined
    abbreviated?: boolean
}>()
</script>

<template>
    <span class="inline-flex items-center gap-1">
        <component :is="getBatteryConfig(status).icon" class="size-3.5" />
        <span>{{ abbreviated ? getBatteryConfig(status).abbr : getBatteryConfig(status).label }}</span>
    </span>
</template>
